import React from 'react';
import glamorous from 'glamorous';
import { map, isEmpty } from 'lodash';

import Chart from './chart';
import Filters from './filters';
import { withSpinner } from '../../utils/hocs';

const DashboardCharts = withSpinner(({ isLoading }) => isLoading)(props => {
  const { dashboardData, yearsRange } = props;

  return (
    <div className="row">
      {map(dashboardData.aggregations, agg => (
        <div className="col-md-6 col-sm-12" key={agg.id}>
          <Chart {...agg} yearsRange={yearsRange} />
        </div>
      ))}
    </div>
  );
});

const Dashboard = (props) => {
  const { dashboardData } = props;
  return (
    <div className="container">
      <glamorous.Div
        css={{
          borderBottom: '1px dotted #dcdedf',
          marginBottom: 20,
        }}
        className="row"
      >
        <div className="col-md-12">
          <glamorous.H2 css={{ marginBottom: 10 }}>
            {dashboardData.label}
          </glamorous.H2>
          <p className="help-block">
            {dashboardData.description}
          </p>
          <br />
        </div>
      </glamorous.Div>
      <Filters {...props} />
      <DashboardCharts {...props} />
    </div>
  );
};

export default Dashboard;



// WEBPACK FOOTER //
// ./src/views/dashboard/index.js